import {FeaturePickerItem} from '@dms/shared';

export const expandSelectedFeatureValues = (
  selected: string[],
  features: FeaturePickerItem[]
): string[] => {
  const featuresByValue = new Map<string, FeaturePickerItem>();

  features.forEach((feature) => addFeatureToMap(feature, featuresByValue));

  return selected.flatMap((value) => {
    const feature = featuresByValue.get(value);

    return feature ? getLeafFeatureValues(feature) : [value];
  });
};

const addFeatureToMap = (
  feature: FeaturePickerItem,
  featuresByValue: Map<string, FeaturePickerItem>
) => {
  featuresByValue.set(feature.value, feature);
  feature.children?.forEach((child) => addFeatureToMap(child, featuresByValue));
};

const getLeafFeatureValues = (feature: FeaturePickerItem): string[] =>
  feature.children?.length ? feature.children.flatMap(getLeafFeatureValues) : [feature.value];
